export const PayrollRunStatus = {
  PENDING: "pending",
  SUBMITTED: "submitted",
} as const;

export type PayrollRunStatus =
  (typeof PayrollRunStatus)[keyof typeof PayrollRunStatus];
